module.exports = __webpack_public_path__ + "img/fiberapi.9b65bd0b.svg";